export default __webpack_public_path__ + "static/media/note.83f228b1.svg";